import React from 'react';

interface TableProps {
  header: string;
  description: string;
}

const InitialReportingTable: React.FC<TableProps> = ({ header, description }) => {
  return (
    <div className="w-full flex justify-center items-center h-[308px]">
      <div className="w-[396px] text-center flex flex-col gap-2">
        <h1 className="text-heading-125 leading-heading font-bold text-gray-925">{header}</h1>
        <p className="text-sm font-normal">{description}</p>
      </div>
    </div>
  );
};

export default InitialReportingTable;
